import { createSelector } from 'reselect';
import { KEY, EventState, KioskEvent, NormalizedKioskEvents } from './types';
import { GlobalState } from 'store/types';

const getEventsState = (state: GlobalState) => state[KEY] as EventState;

const selectLoading = createSelector(getEventsState, (events) => events.loading);

const selectError = createSelector(getEventsState, (events) => events.error);

const selectKioskEvents = createSelector(getEventsState, (events) => events.history.kioskEvents);

const selectKioskHardwareEvents = createSelector(getEventsState, (events) => events.history.kioskHardwareEvents);

const selectLatestKioskEvents = createSelector(getEventsState, (events) =>
  events.latest.kioskEvents.reduce((acc: NormalizedKioskEvents, event: KioskEvent) => {
    acc[event.category] = event;
    return acc;
  }, {})
);

const selectLatestKioskHardwareEvents = createSelector(getEventsState, (events) => events.latest.kioskHardwareEvents);

export const selectors = {
  selectLoading,
  selectError,
  selectKioskEvents,
  selectKioskHardwareEvents,
  selectLatestKioskEvents,
  selectLatestKioskHardwareEvents
};
